// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
// @ts-ignore
import {parse, strftime} from '/util/date.js';

export interface i_category {
    id: string;
    slug: string;
    name: string;
    img: string;
    preview_bg: string;
}
export interface i_article {
    is_404?: boolean;
    title: string;
    img: string;
    preview_bg: string;
    preview_image: string;
    content: string;
    id: string;
    slug: string;
    footer?: string;
    datetime: {
        date: string;
    };
    excerpt: string;
    categories: i_category[];
    time_to_read: string;
    read_counter: string;
    author: {
        name: string;
        img: string;
        position: string;
    };
    seo: {
        title: string;
        description: string;
    };
}
export interface i_arts {
    data: {
        popular: i_article[];
        posts: i_article[];
        categories: i_category[];
        total_posts: number;
        total_pages: number;
        footer?: string;
    };
}
export interface i_article_result {
    data: i_article;
    error: string;
}
export const get_article_date = (art:i_article):string=>{
    const datetime = art.datetime?.date;
    if (!datetime)
        return '';
    // XXX dmitriiz: fix for Safari
    const fix = datetime.replace(' ', 'T');
    const dt_obj = parse(fix) || fix;
    return strftime('%b %d, %Y', dt_obj);
};
export const get_date_obj = (art:i_article):Date=>{
    const datetime = art.datetime.date;
    if (!datetime)
        return new Date();
    // XXX dmitriiz: fix for Safari
    const fix = datetime.replace(' ', 'T');
    const dt_obj = parse(fix);
    return dt_obj;
};
